import { createStyles } from '@mantine/core';
import { ContestStatus, ContestType } from '@betterpool/api-types/contests-service';

import dt from '~/testing';

import ContestCard from '../../common/components/ContestCard/ContestCard';
import type { MyUserContest } from '../types/userContest';
import useGetMyContestBannerInfo from '../hooks/useGetMyContestBannerInfo';
import { ContestTab } from '../hooks/useEntriesTabsProps';

const useStyles = createStyles((theme) => ({
  grid: {
    display: 'grid',
    alignItems: 'stretch',
    gap: theme.spacing.md,
    gridTemplateColumns: 'repeat(3, 1fr)',

    [theme.fn.smallerThan('lg')]: {
      gridTemplateColumns: '1fr 1fr',
    },

    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
}));

type MyContestsProps = {
  contests: MyUserContest[];
  contestTab: ContestTab;
};

function MyContests({ contests, contestTab }: MyContestsProps) {
  const { classes } = useStyles();
  const { getMyContestBannerInfo } = useGetMyContestBannerInfo({
    isEliminationShown: contestTab === ContestTab.ACTIVE,
  });

  return (
    <div className={classes.grid} data-test-id={dt.myContests.layout.content.grid.main}>
      {contests?.map((contest) => (
        <ContestCard
          key={contest.id}
          isSurvivor={
            contest.contest_type === ContestType.TEAM_SURVIVOR ||
            contest.contest_type === ContestType.PLAYER_SURVIVOR
          }
          leaderboard={
            contest.status !== ContestStatus.SCHEDULED ? contest?.leaderboard : undefined
          }
          contest={contest}
          survivor={contest?.survivor}
          isMyContestsView
          isManageContestEnabled={false}
          isContestThumbnailShown
          actionBanner={getMyContestBannerInfo(contest)}
          currentSlateStatus={contest.slate?.status}
          isInvitesManagerEnabled={false}
          isBadgeIconSectionEnabled={false}
        />
      ))}
    </div>
  );
}

export default MyContests;
